<template>
  <div id="app">
    <app-header></app-header>
    <div id="beta-container" class="container-fluid p-0" style="min-height: 90%">
      <router-view />
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import appHeader from "./components/Header";
import appFooter from "./components/Footer";
export default {
  name: "App",
  components: { appHeader, appFooter },
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #16181b;
  height: 100vh;
  font-weight: 300;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: gray;
    }
  }
}
</style>
